import { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { EditGroupForm } from '~/features/EditGroupForm';

export const Screen: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const groupId = Number(id);

  if (Number.isNaN(groupId)) {
    return <div>無効なグループIDです</div>;
  }

  return (
    <Suspense fallback={<div>読み込み中...</div>}>
      <EditGroupForm groupId={groupId} />
    </Suspense>
  );
};
